import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
* This source code is quoted from rc-slider.
* homepage: https://github.com/react-component/slider
*/
import React from 'react';

var Track = function Track(props) {
  //处于激活状态的track
  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      offset = props.offset,
      length = props.length,
      style = props.style,
      reverse = props.reverse;
  var positonStyle = vertical ? reverse ? {
    top: "".concat(offset, "%"),
    height: "".concat(length, "%"),
    bottom: 'auto'
  } : {
    bottom: "".concat(offset, "%"),
    height: "".concat(length, "%"),
    top: 'auto'
  } : reverse ? {
    left: 'auto',
    width: "".concat(length, "%"),
    right: "".concat(offset, "%")
  } : {
    left: "".concat(offset, "%"),
    width: "".concat(length, "%"),
    right: 'auto'
  };

  var elStyle = _objectSpread(_objectSpread({
    visibility: included ? 'visible' : 'hidden'
  }, style), positonStyle);

  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: elStyle
  });
};

export default Track;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-slider/src/common/Track.js